module.exports = __webpack_public_path__ + "static/media/NO HOLES.342d1845.svg";